import { useFilterPurchaseOrderStore } from "presentation/stores/use-filter-purchase-order-store";
import { usePurchaseOrderStore } from "presentation/stores/use-purchase-order-store";
import { Button } from "primereact/button";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

const HeaderPurchaseOrderGrid: React.FC = () => {
  const [globalFilterValue, setGlobalFilterValue] = useState<string>("");
  const { filters, setFilters, resetFilters } = useFilterPurchaseOrderStore();
  const navigate = useNavigate();
  const { resetPurchaseOrder } = usePurchaseOrderStore();

  const clearFilter = () => {
    resetFilters();
    setGlobalFilterValue("");
  };

  const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      let _filters = { ...filters };
      // @ts-ignore
      _filters["query"].value = globalFilterValue;
      setFilters(_filters);
    }
  };

  const onGlobalFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setGlobalFilterValue(e.target.value);
  };

  const addPurchaseOrder = () => {
    resetPurchaseOrder();
    navigate("/purchaseOrders/new");
  };

  return (
    <div className="flex justify-content-between">
      <div>
        <IconField iconPosition="left">
          <InputIcon className="pi pi-search" />
          <InputText
            value={globalFilterValue}
            onChange={onGlobalFilterChange}
            onKeyDown={onKeyDown}
            placeholder="Search"
          />
        </IconField>
      </div>
      <div style={{ display: "flex" }}>
        <Button
          type="button"
          icon="pi pi-plus"
          label="Nova Ordem de Compra"
          outlined
          onClick={addPurchaseOrder}
          style={{
            backgroundColor: "#2196f3",
            color: "white",
            borderRadius: "8px",
          }}
        />
        <div style={{ width: "10px" }}></div>
        <Button
          type="button"
          icon="pi pi-filter-slash"
          label="Limpar"
          outlined
          onClick={clearFilter}
          style={{
            backgroundColor: "white",
            borderColor: "#2196f3",
            color: "#2196f3",
            borderRadius: "8px",
          }}
        />
      </div>
    </div>
  );
};
export default HeaderPurchaseOrderGrid;
